var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebbSchoolLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 332,
    viewBox: "0 0 400 332",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.64 238.014L106.24 44.7559L95.22 0H0L58.64 238.014Z",
    fill: "url(#paint0_linear_3_8)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163.68 0H258.9L177.11 332H81.89L163.68 0Z",
    fill: "url(#paint1_linear_3_8)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M304.78 0H400L318.21 332H222.99L304.78 0Z",
    fill: "url(#paint2_linear_3_8)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.21 186.973L106.24 44.7559L95.22 0H81.89L71.21 186.973Z",
    fill: "url(#paint3_linear_3_8)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.47 96.6289L58.64 238.014L0 0L93.47 96.6289Z",
    fill: "url(#paint4_linear_3_8)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M199.17 0H258.9L177.11 332H140.75L199.17 0Z",
    fill: "url(#paint5_linear_3_8)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M224.63 139.109L140.75 332H81.89L224.63 139.109Z",
    fill: "url(#paint6_linear_3_8)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M400 0L318.21 332H271.15L400 0Z",
    fill: "url(#paint7_linear_3_8)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M400 0L352.39 193.258L304.78 0H400Z",
    fill: "url(#paint8_linear_3_8)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_8",
    x1: 106.245,
    y1: 119.006,
    x2: 0,
    y2: 119.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_8",
    x1: 258.901,
    y1: 166,
    x2: 81.892,
    y2: 166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3F76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C09C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_8",
    x1: 400,
    y1: 166,
    x2: 222.99,
    y2: 166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0058FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#570057"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3_8",
    x1: 106.245,
    y1: 93.4858,
    x2: 71.2094,
    y2: 93.4858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3_8",
    x1: 93.4666,
    y1: 119.006,
    x2: 0,
    y2: 119.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3_8",
    x1: 258.901,
    y1: 166,
    x2: 140.755,
    y2: 166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3F76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C09C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3_8",
    x1: 224.63,
    y1: 235.557,
    x2: 81.892,
    y2: 235.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3F76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C09C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3_8",
    x1: 400,
    y1: 166,
    x2: 271.15,
    y2: 166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0058FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#570057"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3_8",
    x1: 400,
    y1: 96.6271,
    x2: 304.781,
    y2: 96.6271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0058FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#570057"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebbSchoolLogo);
export default __webpack_public_path__ + "static/media/webb-school-logo.c77a7a511485e1bb0f0102e726b0082d.svg";
export { ForwardRef as ReactComponent };